/**
 * Shared constants
 */

export const DEBUG_MODE = false;
